"use client";

import * as SwitchPrimitives from "@radix-ui/react-switch";
import * as React from "react";

import { cn } from "@frontend/shared/lib/utils";

const Switch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root>
>(({ className, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer inline-flex h-4 w-7 shrink-0 cursor-pointer items-center rounded-full border-2 border-transparent transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50 data-[state=checked]:bg-superscriptBlue data-[state=unchecked]:bg-[#000000]",
      className,
    )}
    {...props}
    ref={ref}
  >
    <SwitchPrimitives.Thumb
      className={cn(
        "pointer-events-none block h-3 w-3 rounded-full bg-background shadow-lg ring-0 transition-transform data-[state=checked]:translate-x-3 data-[state=unchecked]:translate-x-0",
      )}
    />
  </SwitchPrimitives.Root>
));
Switch.displayName = SwitchPrimitives.Root.displayName;

const PriceSwitch = React.forwardRef<
  React.ElementRef<typeof SwitchPrimitives.Root>,
  React.ComponentPropsWithoutRef<typeof SwitchPrimitives.Root> & {
    backgroundColor?: string;
  }
>(({ className, children, backgroundColor, checked, ...props }, ref) => (
  <SwitchPrimitives.Root
    className={cn(
      "peer flex h-[36px] w-[64px] shrink-0 py-[2px] cursor-pointer items-center rounded-full transition-colors focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background disabled:cursor-not-allowed disabled:opacity-50",
      "relative",
      "data-[state=checked]:bg-[#C0E7EB] data-[state=unchecked]:bg-[#D3D3D3]",
      className,
    )}
    checked={checked}
    {...props}
    ref={ref}
    style={
      backgroundColor && checked
        ? { backgroundColor, borderRadius: "100px" }
        : undefined
    }
  >
    <div className="pointer-events-none relative z-10 h-full w-full rounded-full flex items-center">
      <SwitchPrimitives.Thumb
        className={cn(
          "shadow-[0_0_5px_0_#A6ABBD] pointer-events-none block h-[28px] w-[28px] relative overflow-hidden rounded-full ring-0 transition-transform data-[state=unchecked]:bg-background data-[state=checked]:translate-x-[34px] data-[state=unchecked]:translate-x-[2px]",
        )}
      >
        {children}
      </SwitchPrimitives.Thumb>
    </div>
  </SwitchPrimitives.Root>
));
PriceSwitch.displayName = SwitchPrimitives.Root.displayName;

export { Switch, PriceSwitch };
